<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-header">Все сотрудники</div>
					<div class="card-body">
						<p><router-link to="/users/create" class="btn btn-primary"><i class="fa fa-plus"></i> Новый сотрудник</router-link></p>
						<vuetable ref="vuetable"
							:fields="columns"
							:api-mode="false"
							:data="tableData"
							@vuetable:cell-dblclicked="rowClickHandler"
							class="table-striped">
							<template slot="name" slot-scope="props">
								{{ props.rowData.first_name }} {{ props.rowData.last_name }}
							</template>
							<template slot="created_at" slot-scope="props">
								{{ dateFormat(props.rowData.created_at) }}
							</template>
							<template slot="role" slot-scope="props">
								<div v-for="(role, key) in roles" :key="key">
									<div v-if="role.system_name === props.rowData.role">
										{{ role.name }}
									</div>
								</div>
							</template>
							<template slot="status" slot-scope="props">
								<b-badge v-if="props.rowData.status === 0" variant="warning">неактивированный</b-badge>
								<b-badge v-if="props.rowData.status === 1" variant="success">активен</b-badge>
								<b-badge v-if="props.rowData.status === 2" variant="warning">заблокированный</b-badge>
							</template>
						</vuetable>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment'
import userAPI from '@/api/modules/user/user'
import Vue from 'vue'
import store from '@/store'
export default {
	data: () => {
		return {
			columns: [
				{
					name: 'id',
					title: 'ID'
				}, {
					name: 'email',
					title: 'Адрес электронной почты'
				}, {
					name: '__slot:name',
					title: 'Имя, фамилия'
				}, {
					name: '__slot:created_at',
					title: 'Дата регистрации'
				}, {
					name: '__slot:role',
					title: 'Роль'
				}, {
					name: '__slot:status',
					title: 'Статус'
				}
			],
			options: {},
			tableData: [],
			roles: []
		}
	},
	mounted: function () {
		this.roleAll()
		this.getUsers()
	},
	methods: {
		roleAll () {
			Vue.http.get(store.state.apiURL + '/v1/user/roles').then((response) => {
				this.roles = response.body
			})
		},
		getUsers: function () {
			userAPI.findAll().then((response) => {
				this.tableData = response
			}, function (response) {
			})
		},
		dateFormat: function (date) {
			return moment(date).format('DD.MM.Y')
		},
		rowClickHandler (dataItem, field, event) {
			this.$router.push({path: `/users/${dataItem.id}/update`})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/user/index.vue